import { notification } from 'antd'
import i18next from 'i18next'
import { makeAutoObservable } from 'mobx'
import { captureException } from '@sentry/react'

import { getSharedKey } from 'utils/helpers/i18n/getKeys'

import { ordersApi } from '../../api'
import { OrderKeys } from '../../data'
import { OrderStatus } from '../../types'
import { ActivateOrderUiStore } from './ActivateOrderUiStore'

const getKey = (key: string) => `${OrderKeys.orderModule}.api.${key}`

export class ActivateOrderApiStore {
  constructor(protected readonly uiStore: ActivateOrderUiStore) {
    makeAutoObservable(this)
  }

  async updateOrder(orderId: number, disableLoadList: boolean = false) {
    if (!this.uiStore.selectedOrder) {
      return
    }

    const actualUrls = await this.uiStore.fileList.processFiles(this.uiStore.selectedOrder)
    const status = this.uiStore.selectedOrder?.status

    if (!actualUrls) {
      captureException(`Ошибка загрузки файлов для активации заявки № ${orderId}`)
      throw new Error(i18next.t(getSharedKey('api.filesUploadError')))
    }

    try {
      await this.uiStore.rootStore.orderStore.updateOrder(
        {
          id: orderId,
          actualUrls,
          signboardSize: this.uiStore.signboardSizeItem?.value,
          signboardFormat: this.uiStore.signboardFormatItem?.value,
          comment: this.uiStore.comment.trim(),
          glnPvz: this.uiStore.glnPvz.trim(),
          molName: this.uiStore.molName.trim(),
          ownerGln: this.uiStore.ownerGln.trim(),
        },
        disableLoadList,
      )

      if (status === OrderStatus.remarkFromActivate) {
        notification.success({ message: i18next.t(getKey('updateOrderSuccess'), { count: orderId }) })
      }
    } catch (error) {
      captureException(`Не удалось обновить заявку для активации заявки № ${orderId}`)
      throw new Error(i18next.t(getSharedKey('api.filesUploadError')))
    }
  }

  async makeOrderReadyActivate(orderId: number) {
    try {
      await ordersApi.makeOrderReadyActivate({
        orderId,
        glnPvz: this.uiStore.glnPvz.trim(),
        molName: this.uiStore.molName.trim(),
        ownerGln: this.uiStore.ownerGln.trim(),
      })
      notification.success({ message: i18next.t(getKey('activateOrderSuccess'), { count: orderId }) })
    } catch (error) {
      captureException(`Не удалось отправить заявку № ${orderId} на активацию. ${(error as Error).message}`)
      throw new Error(`${i18next.t(getKey('makeOrderReadyActivateError'))}. ${(error as Error).message}`)
    }
  }
}
